var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[_c('AddParceiro')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }